import { VehicleType } from "@tm/models"
import { useMemo } from "react"
import { useLocation, useRouteMatch } from "react-router"

export type VehicleUrlParameter = {
    query: string
    regNoType?: number
    regNo?: string
    engineCode?: string
    checkAndMergeRegNoDetails?: boolean
    forceUpdate?: boolean
    autoApplySingleVehicle?: boolean
    allowVehicleChange?: boolean
    plateId?: string
    vin?: string
    initialRegistration?: string
    licensePlateSearchQuery?: string
    vehicleType: VehicleType
}

export const VehicleParams = {
    Query: "query",
    RegNo: "regNo",
    RegNoType: "regNoType",
    EngineCode: "engineCode",
    CheckAndMergeRegNoDetails: "checkAndMergeRegNoDetails",
    ForceUpdate: "forceUpdate",
    AutoApplySingleVehicle: "autoApplySingleVehicle",
    AllowVehicleChange: "allowVehicleChange",
    PlateId: "plateId",
    Vin: "vin",
    InitialRegistration: "initialRegistration",
    LicensePlateSearchQuery: "lpquery",
    VehicleType: "vtype",
}

export function useVehicleUrlParameter() {
    const { search } = useLocation()
    // we need to support a option for the old logic of vehicleTypes
    const match = useRouteMatch<{ vehicleType: string }>()

    const vehicleUrlParameter: VehicleUrlParameter = useMemo(() => {
        const searchParams = new URLSearchParams(search)
        return {
            query: searchParams.get(VehicleParams.Query) || "",
            regNoType: parseInt(searchParams.get(VehicleParams.RegNoType) || ""),
            regNo: searchParams.get(VehicleParams.RegNo) || undefined,
            engineCode: searchParams.get(VehicleParams.EngineCode) || undefined,
            checkAndMergeRegNoDetails: searchParams.get(VehicleParams.CheckAndMergeRegNoDetails) === "true",
            forceUpdate: searchParams.get(VehicleParams.ForceUpdate) === "true",
            autoApplySingleVehicle: searchParams.get(VehicleParams.AutoApplySingleVehicle) === "true",
            allowVehicleChange: searchParams.get(VehicleParams.AllowVehicleChange) === "true",
            plateId: searchParams.get(VehicleParams.PlateId) || undefined,
            vin: searchParams.get(VehicleParams.Vin) || undefined,
            initialRegistration: searchParams.get(VehicleParams.InitialRegistration) || undefined,
            licensePlateSearchQuery: searchParams.get(VehicleParams.LicensePlateSearchQuery) || undefined,
            vehicleType: parseInt(searchParams.get(VehicleParams.VehicleType) || match.params.vehicleType || "1"),
        }
    }, [search, match.params.vehicleType])

    return vehicleUrlParameter
}
